module.exports = __webpack_public_path__ + "img/Sithlördchen.72b411a7.svg";